export default function getDeviceLocale() {
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language
}
